import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page play-page" }
const _hoisted_2 = {
  key: 0,
  class: "win-flash"
}
const _hoisted_3 = { class: "top-hud" }
const _hoisted_4 = { class: "skin-selector" }
const _hoisted_5 = ["title", "onClick"]
const _hoisted_6 = { class: "skin-icon" }
const _hoisted_7 = { class: "hud-right" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "pnl-scope" }
const _hoisted_10 = { class: "pnl-amount mono" }
const _hoisted_11 = {
  key: 1,
  class: "sparkline"
}
const _hoisted_12 = { class: "streak-icon" }
const _hoisted_13 = { class: "control-group" }
const _hoisted_14 = { class: "odds-slider" }
const _hoisted_15 = { class: "odds-readout" }
const _hoisted_16 = { class: "odds-step-label" }
const _hoisted_17 = { class: "odds-stats" }
const _hoisted_18 = { class: "win-pct" }
const _hoisted_19 = { class: "payout-mult" }
const _hoisted_20 = ["min", "max", "disabled"]
const _hoisted_21 = { class: "auto-selector" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "hotkey-hint"
}
const _hoisted_25 = {
  key: 2,
  class: "error-toast"
}
const _hoisted_26 = { class: "slab-label" }
const _hoisted_27 = { class: "slab-amount mono" }
const _hoisted_28 = {
  class: "hist-modal",
  role: "dialog",
  "aria-label": "Game history"
}
const _hoisted_29 = { class: "hist-header" }
const _hoisted_30 = { class: "hist-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StalledBets = _resolveComponent("StalledBets")!
  const _component_TierSelector = _resolveComponent("TierSelector")!
  const _component_GameHistoryList = _resolveComponent("GameHistoryList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.winFlash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skins, (skin) => {
          return (_openBlock(), _createElementBlock("button", {
            key: skin.id,
            class: _normalizeClass(["skin-chip", { selected: _ctx.currentSkinId === skin.id }]),
            title: skin.name,
            onClick: ($event: any) => (_ctx.selectSkin(skin.id))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(skin.icon), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["pnl-pill", _ctx.pnlClass]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePnlScope && _ctx.togglePnlScope(...args))),
          title: `Click to switch — currently ${_ctx.pnlScope}`
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.pnlScope), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedPnl), 1)
        ], 10, _hoisted_8),
        _createElementVNode("button", {
          class: "history-btn",
          title: "Game history",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
        }, "♣"),
        _createVNode(_component_router_link, {
          to: "/how-it-works",
          class: "history-btn help-btn",
          title: "How it works"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("?", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_StalledBets),
    (_ctx.sparkline.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sparkline, (r, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: r.key,
              class: _normalizeClass(["spark-dot", r.won ? 'win' : 'loss']),
              style: _normalizeStyle({ animationDelay: `${(_ctx.sparkline.length - 1 - i) * 12}ms` })
            }, null, 6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["skin-area", { playing: _ctx.isFlipping }])
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentSkin.component), {
        state: _ctx.skinState,
        tier: _ctx.selectedTier,
        "odds-edge-bps": _ctx.oddsEdgeBps,
        dust: _ctx.dust,
        onLaunch: _ctx.onSkinLaunch,
        onCashout: _ctx.onSkinCashout
      }, null, 40, ["state", "tier", "odds-edge-bps", "dust", "onLaunch", "onCashout"]))
    ], 2),
    _createVNode(_Transition, { name: "streak-pop" }, {
      default: _withCtx(() => [
        (_ctx.streak.count >= 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["streak-badge", _ctx.streak.kind])
            }, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.streak.kind === 'win' ? '🔥' : '❄'), 1),
              _createTextVNode(" STREAK ×" + _toDisplayString(_ctx.streak.count), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["controls", { inert: _ctx.isFlipping && !_ctx.isAutoRunning }])
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_TierSelector, {
          tiers: _ctx.tiers,
          "selected-tier": _ctx.selectedTier,
          "affordable-tiers": _ctx.affordableTiers,
          "player-balance": _ctx.playerBalance,
          onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedTier = $event))
        }, null, 8, ["tiers", "selected-tier", "affordable-tiers", "player-balance"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.stepLabel), 1),
          _createElementVNode("span", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.winPctLabel) + " win", 1),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.payoutMult(_ctx.selectedBet)), 1)
          ])
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "odds-range",
          type: "range",
          min: _ctx.minStep,
          max: _ctx.maxStep,
          step: "1",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sliderIndex) = $event)),
          disabled: _ctx.isAutoRunning,
          "aria-label": "Odds"
        }, null, 8, _hoisted_20), [
          [
            _vModelText,
            _ctx.sliderIndex,
            void 0,
            { number: true }
          ]
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "odds-ends" }, [
          _createElementVNode("span", null, "safer · bigger chance"),
          _createElementVNode("span", null, "riskier · bigger payout")
        ], -1))
      ]),
      (!_ctx.skinOwnsGesture)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoOptions, (opt) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: opt.label,
                  class: _normalizeClass(["auto-chip", { selected: _ctx.autoCount === opt.value }]),
                  disabled: _ctx.isAutoRunning,
                  onClick: ($event: any) => (_ctx.selectAuto(opt.value))
                }, _toDisplayString(opt.label), 11, _hoisted_22))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["flip-btn", { active: _ctx.canFlip, stop: _ctx.isAutoRunning }]),
              disabled: !_ctx.canFlip && !_ctx.isAutoRunning,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doFlip && _ctx.doFlip(...args)))
            }, [
              (_ctx.isAutoRunning)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("STOP (" + _toDisplayString(_ctx.autoRemainingLabel) + " LEFT)", 1)
                  ], 64))
                : (_ctx.isAutoMode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.isFlipping ? 'FLIPPING...' : `AUTO ×${_ctx.autoCountLabel}`), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(_ctx.isFlipping ? 'FLIPPING...' : 'FLIP IT'), 1)
                    ], 64))
            ], 10, _hoisted_23),
            (!_ctx.isAutoMode && !_ctx.isFlipping && _ctx.canFlip)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Press Enter to flip"))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slab" }, {
      default: _withCtx(() => [
        (_ctx.slab)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["result-slab", _ctx.slab.won ? 'win' : 'loss'])
            }, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.slab.won ? 'YOU WIN' : 'YOU LOSE'), 1),
              _createElementVNode("div", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.slab.won ? '+' : '−') + _toDisplayString(Math.abs(_ctx.slab.amount).toLocaleString()) + " ", 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "slab-unit" }, "sats", -1))
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "hist-fade" }, {
      default: _withCtx(() => [
        (_ctx.historyOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "hist-backdrop",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.historyOpen = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("header", _hoisted_29, [
                  _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "hist-title" }, "Game History", -1)),
                  _createElementVNode("button", {
                    class: "hist-close",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.historyOpen = false)),
                    "aria-label": "Close"
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_GameHistoryList, { games: _ctx.historyGames }, null, 8, ["games"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}